import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId/identity')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/identity-edit-page')),
  staticData: { titleKey: 'identity' },
});
